import { render, staticRenderFns } from "./Exim.vue?vue&type=template&id=3a140e56"
import script from "./Exim.vue?vue&type=script&lang=js"
export * from "./Exim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports